// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__YIv-7"};